var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAolMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.25,
    width: 31.5,
    height: 31.5,
    rx: 7.75,
    fill: "white",
    stroke: "#E0E6EE",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5612_108296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0303 13.0601C17.2391 13.0601 16.4658 13.2947 15.808 13.7342C15.1502 14.1737 14.6375 14.7984 14.3348 15.5293C14.032 16.2602 13.9528 17.0645 14.1071 17.8404C14.2615 18.6163 14.6424 19.3291 15.2018 19.8885C15.7613 20.4479 16.474 20.8289 17.2499 20.9832C18.0258 21.1375 18.8301 21.0583 19.561 20.7556C20.2919 20.4528 20.9166 19.9401 21.3562 19.2823C21.7957 18.6245 22.0303 17.8512 22.0303 17.0601C22.0303 16.5348 21.9268 16.0146 21.7258 15.5293C21.5248 15.044 21.2301 14.6031 20.8587 14.2316C20.4873 13.8602 20.0463 13.5656 19.561 13.3645C19.0757 13.1635 18.5556 13.0601 18.0303 13.0601ZM18.0303 18.5001C17.7324 18.506 17.4395 18.4231 17.1889 18.262C16.9383 18.1008 16.7414 17.8687 16.6233 17.5952C16.5051 17.3217 16.4711 17.0192 16.5255 16.7262C16.58 16.4333 16.7204 16.1633 16.929 15.9505C17.1375 15.7377 17.4047 15.5918 17.6964 15.5315C17.9882 15.4711 18.2913 15.499 18.5672 15.6116C18.843 15.7242 19.0791 15.9164 19.2452 16.1637C19.4114 16.411 19.5002 16.7021 19.5003 17.0001C19.5003 17.3979 19.3422 17.7794 19.0609 18.0607C18.7796 18.342 18.3981 18.5001 18.0003 18.5001H18.0303Z",
    fill: "#303C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 11H23C22.7239 11 22.5 11.2239 22.5 11.5V20.5C22.5 20.7761 22.7239 21 23 21H25C25.2761 21 25.5 20.7761 25.5 20.5V11.5C25.5 11.2239 25.2761 11 25 11Z",
    fill: "#303C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 21C28.0523 21 28.5 20.5523 28.5 20C28.5 19.4477 28.0523 19 27.5 19C26.9477 19 26.5 19.4477 26.5 20C26.5 20.5523 26.9477 21 27.5 21Z",
    fill: "#303C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9696 11.32C10.9331 11.2252 10.8685 11.1439 10.7845 11.0867C10.7006 11.0295 10.6012 10.9993 10.4996 11H8.49962C8.39805 10.9993 8.29867 11.0295 8.21471 11.0867C8.13075 11.1439 8.06619 11.2252 8.02962 11.32L4.52962 20.32C4.50028 20.396 4.48997 20.4781 4.49959 20.559C4.5092 20.6399 4.53845 20.7173 4.58478 20.7843C4.63111 20.8514 4.69313 20.906 4.76544 20.9436C4.83774 20.9812 4.91813 21.0006 4.99962 21H6.99962C7.10742 21.0064 7.21439 20.9777 7.30452 20.9182C7.39465 20.8587 7.46309 20.7716 7.49962 20.67L7.91962 19.5H11.1096L11.4996 20.67C11.5362 20.7716 11.6046 20.8587 11.6947 20.9182C11.7849 20.9777 11.8918 21.0064 11.9996 21H13.9996C14.0811 21.0006 14.1615 20.9812 14.2338 20.9436C14.3061 20.906 14.3681 20.8514 14.4145 20.7843C14.4608 20.7173 14.49 20.6399 14.4997 20.559C14.5093 20.4781 14.499 20.396 14.4696 20.32L10.9696 11.32ZM10.0396 16.5H8.95962L9.49962 15L10.0396 16.5Z",
    fill: "#303C42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5612_108296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4.5 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAolMail);
export default __webpack_public_path__ + "static/media/aol-mail.7e0f5f678435cc91d9195b63007cfd80.svg";
export { ForwardRef as ReactComponent };